import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SuspendedIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 16 16">
      <path d="M7.25 10.25H8.75V11.75H7.25V10.25ZM7.25 4.25H8.75V8.75H7.25V4.25ZM7.9925 0.5C3.8525 0.5 0.5 3.86 0.5 8C0.5 12.14 3.8525 15.5 7.9925 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 7.9925 0.5ZM8 14C4.685 14 2 11.315 2 8C2 4.685 4.685 2 8 2C11.315 2 14 4.685 14 8C14 11.315 11.315 14 8 14Z" fill="currentColor"/>
    </SvgIcon>
  );
};

export default SuspendedIcon;
